import type { QuotaStateForOrgResponse } from "@glide/common-core/dist/js/firebase-function-types";
import { useQuery } from "@tanstack/react-query";

import { getQuotaStateForOrg } from "../lib/usage-lib";

export function useQuotaState(orgID: string | undefined): {
    data: QuotaStateForOrgResponse | undefined;
    isLoading: boolean;
} {
    const { data, isLoading } = useQuery(
        ["useQuotaState", orgID ?? "never happens"],
        async ({ queryKey: [, id] }) => {
            // From useQuery docs:
            // Must return a promise that will either resolve data or throw an error. The data cannot be undefined.
            return (await getQuotaStateForOrg(id)) ?? null;
        },
        {
            enabled: orgID !== undefined && orgID !== "0",
            refetchInterval: 60_000,
            staleTime: Infinity,
            cacheTime: 5_000,
        }
    );

    // And here we return undefined to keep the existing API
    return { data: data ?? undefined, isLoading };
}
